// Функция для плавной прокрутки страницы наверх
function scrollToTop() {
    let currentPosition = document.documentElement.scrollTop || document.body.scrollTop
    if (currentPosition > 0) {
        window.requestAnimationFrame(scrollToTop)
        window.scrollTo(0, currentPosition - currentPosition / 6)
    }
}
window.onload = function () {
    // Получаем кнопку "наверх"
    let scrollBtn = document.getElementById('scrollBtn')
    if (scrollBtn) {
        // При прокрутке страницы показываем или скрываем кнопку
        window.onscroll = function () {
            if (document.body.scrollTop > 700 || document.documentElement.scrollTop > 700) {
                scrollBtn.style.display = 'block'
            } else {
                scrollBtn.style.display = 'none'
            }
        }
        // При клике на кнопку плавно прокручиваем страницу наверх
        scrollBtn.onclick = function () {
            scrollToTop()
        }
    }
}
